import React from 'react';
import classNames from 'classnames';
import { LoadingOutlined, FileOutlined, MinusSquareOutlined, PlusSquareOutlined, CaretDownFilled, } from '@ant-design/icons';
export default function renderSwitcherIcon(prefixCls, switcherIcon, showLine, { isLeaf, expanded, loading }) {
    if (loading) {
        return <LoadingOutlined className={`${prefixCls}-switcher-loading-icon`}/>;
    }
    if (isLeaf) {
        return showLine ? <FileOutlined className={`${prefixCls}-switcher-line-icon`}/> : null;
    }
    const switcherCls = `${prefixCls}-switcher-icon`;
    if (React.isValidElement(switcherIcon)) {
        return React.cloneElement(switcherIcon, {
            className: classNames(switcherIcon.props.className || '', switcherCls),
        });
    }
    if (switcherIcon) {
        return switcherIcon;
    }
    if (showLine) {
        return expanded ? (<MinusSquareOutlined className={`${prefixCls}-switcher-line-icon`}/>) : (<PlusSquareOutlined className={`${prefixCls}-switcher-line-icon`}/>);
    }
    return <CaretDownFilled className={switcherCls}/>;
}
